import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import Message from "../../enums/Message";
import {graphql} from "react-apollo/lib/index";
import UpdateIgnoreScannedLabelMutation from "../../graphql/UpdateIgnoreScannedLabelMutation.graphql";
import ImportButton from "./ImportButton";
import LabelRow from "./LabelRow";
import DefaultLanguageSelect from "./DefaultLanguageSelect";

@graphql(
	UpdateIgnoreScannedLabelMutation, {
		name: 'updateScannedLabel'
	}
)
export default class NewLabels extends Component {
	constructor(prop) {
		super(prop);

		this.state = {
			selectedNewLabels: [],
			defaultLanguage: ""
		};
	}

	static propTypes = {
		status: PropTypes.object,
		data: PropTypes.object,
		selectedProject: PropTypes.object,
		newLabels: PropTypes.array,
	};

	selectAllNew = (event) => {
		let newLabels = [];
		if (event.target.checked) {
			_.map(this.props.data.project.codeScan.newLabels, (newLabel) => {
				if (!newLabel.scannedLabel.ignored) {
					newLabels.push(newLabel.scannedLabel.identifier)
				}
			})
		}
		this.setState({
			selectedNewLabels: newLabels
		})
	};


	updateNewSelection = (event) => {
		let selectedNewLabelsCopy = this.state.selectedNewLabels;
		if (event.target.checked) {
			selectedNewLabelsCopy.push(event.target.id)
		} else {
			selectedNewLabelsCopy.splice(selectedNewLabelsCopy.indexOf(event.target.id), 1)
		}
		this.setState({
			selectedNewLabels: selectedNewLabelsCopy
		})
	};

	toggleIgnoreScannedLabel = (scannedLabel, key) => {
		const newStatus = !scannedLabel.ignored;
		const newScannedLabels = [...this.props.data.project.codeScan.newLabels];

		newScannedLabels[key].scannedLabel.ignored = newStatus;
		this.setState({
			newLabels: newScannedLabels
		});

		this.props.updateScannedLabel({
			variables: {
				input: {
				    projectName: this.props.selectedProject.name,
					identifier: scannedLabel.scannedLabelCollection.identifier,
					name: scannedLabel.name,
					value: newStatus
				}
			}
		}).then(
			result => {

			},
			error => {
				this.props.addMessage(new Message(
					Message.TYPE_ERROR,
					500,
					'Could not update ScannedLabel: ' + error.message
				));
			}
		)
	};

	render() {
		const {status, data, newLabels} = this.props;

		return (
			<div className="tab-pane active" id="home" role="tabpanel" aria-expanded="true">
				<div className="table-responsive">
					<div className="table-responsive">
						<table className="table">
							<thead className="">
							<tr>
								<th>
									<div className="form-check xpull-left">
										<label className="form-check-label">
											<input type="checkbox" id="newNotIgnored" value=""
												   onChange={this.selectAllNew}/>
											<span className="form-check-sign"/>
										</label>
									</div>
								</th>
								<th>Ignore</th>
								<th>Collection</th>
								<th>id</th>
								<th>default</th>
								<th>File:Line</th>
							</tr>
							</thead>
							<tbody>
							{_.map(newLabels, (newLabel, key) => {
								if (!newLabel.scannedLabel.ignored) {
									return (
										<LabelRow label={newLabel.scannedLabel}
												  isRunning={status.project.codeScan.isRunning}
												  git={data.project.git}
												  isChecked={this.state.selectedNewLabels.includes(newLabel.scannedLabel.identifier)}
												  rowKey={key}
												  key={key}
												  sourceBranch={data.project.sourceBranch}
												  toggleIgnoreScannedLabel={this.toggleIgnoreScannedLabel}
												  updateNewSelection={this.updateNewSelection}
										/>
									)
								}
							})}
							</tbody>
						</table>
						<h3>Ignored:</h3>
						<table className="table">
							<thead className="">
							<tr>
								<th>Ignore</th>
								<th>Collection</th>
								<th>id</th>
								<th>default</th>
								<th>File:Line</th>
							</tr>
							</thead>
							<tbody>
							{_.map(newLabels, (newLabel, key) => {
								if (newLabel.scannedLabel.ignored) {
									return (
										<LabelRow label={newLabel.scannedLabel}
												  isRunning={status.project.codeScan.isRunning}
												  git={data.project.git}
												  isChecked={this.state.selectedNewLabels.includes(newLabel.scannedLabel.identifier)}
												  rowKey={key}
												  key={key}
												  sourceBranch={data.project.sourceBranch}
												  toggleIgnoreScannedLabel={this.toggleIgnoreScannedLabel}
												  updateNewSelection={this.updateNewSelection}
												  isIgnored={true}
										/>
									)
								}
							})}
							</tbody>
						</table>
					</div>
				</div>
				<div>
					<DefaultLanguageSelect languages={data.project.languages} setDefaultLanguage={(language) => this.setState({defaultLanguage: language})}/>
					<ImportButton
						text={"Import new labels"}
						data={data}
						isDisabled={status.project.codeScan.isRunning}
						labelsToImport={this.state.selectedNewLabels}
						defaultLanguage={this.state.defaultLanguage}
						isScannedLabels={true}
						selectedProject={this.props.selectedProject}
						afterImportCallback={() => {
							this.setState({selectedNewLabels: []})
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/NewLabels.js